"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledFeatureDto = void 0;
const AppDto_1 = require("../apps/AppDto");
const LocationDto_1 = require("../locations/LocationDto");
class DisabledFeatureDto {
    constructor(params) {
        this.disabledFeatureType = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.appId = params.appId;
        this.disabledFeatureType = params.disabledFeatureType;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app === null ? null :
                new AppDto_1.AppDto(params.app);
        }
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.DisabledFeatureDto = DisabledFeatureDto;
//# sourceMappingURL=DisabledFeatureDto.js.map